import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_USER_SEARCH_LIST: any = createRequestTypes('permissions/FETCH_USER_SEARCH_LIST');
export const FETCH_USER_DETAILS: any = createRequestTypes('permissions/FETCH_USER_DETAILS');
export const UPDATE_USER_DETAILS: any = createRequestTypes('permissions/UPDATE_USER_DETAILS');
export const CREATE_USER: any = createRequestTypes('permissions/CREATE_USER');
export const UPDATE_USER_ROLES: any = createRequestTypes('permissions/UPDATE_USER_ROLES');
export const UPDATE_USER_ODIN_PERMISSIONS: any = createRequestTypes('permissions/UPDATE_USER_ODIN_PERMISSIONS');
export const RESET_PERMISSION_STATE: any = createRequestTypes('permissions/RESET_PERMISSION_STATE');
export const fetchUserSearchList = {
  request: (params: any) => createAction(FETCH_USER_SEARCH_LIST[REQUEST], { params }),
  success: (response: any, params: any) => createAction(FETCH_USER_SEARCH_LIST[SUCCESS], { response, params }),
  failure: () => createAction(FETCH_USER_SEARCH_LIST[FAILURE], {}),
};

export const fetchUserDetails = {
  request: (params: any) => createAction(FETCH_USER_DETAILS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(FETCH_USER_DETAILS[SUCCESS], { response, params }),
  failure: () => createAction(FETCH_USER_DETAILS[FAILURE], {}),
};

export const updateUserDetails = {
  request: (params: any) => createAction(UPDATE_USER_DETAILS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(UPDATE_USER_DETAILS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(UPDATE_USER_DETAILS[FAILURE], { response }),
};

export const createUser = {
  request: (params: any) => createAction(CREATE_USER[REQUEST], { params }),
  success: (response: any, params: any) => createAction(CREATE_USER[SUCCESS], { response, params }),
  failure: (response: any) => createAction(CREATE_USER[FAILURE], { response }),
};

export const updateUserRoles = {
  request: (params: any) => createAction(UPDATE_USER_ROLES[REQUEST], { params }),
  success: (response: any, params: any) => createAction(UPDATE_USER_ROLES[SUCCESS], { response, params }),
  failure: (response: any) => createAction(UPDATE_USER_ROLES[FAILURE], { response }),
};

export const updateUserPermissions = {
  request: (params: any) => createAction(UPDATE_USER_ODIN_PERMISSIONS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(UPDATE_USER_ODIN_PERMISSIONS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(UPDATE_USER_ODIN_PERMISSIONS[FAILURE], { response }),
};
export const resetOdinPermissionsState = {
  request: () => createAction(RESET_PERMISSION_STATE[REQUEST]),
  success: (response: any, params: any) => createAction(RESET_PERMISSION_STATE[SUCCESS], { response, params }),
  failure: (response: any) => createAction(RESET_PERMISSION_STATE[FAILURE], { response }),
};
